module.exports = "<main role=\"main\" class=\"container\">\n  <h1>Dashboard component</h1>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.html
// module id = ./src/app/dashboard/dashboard.component.html
// module chunks = main